import React from "react";
import Modal from "components/Modal/Modal";
import { ModalProps } from "../Modal/Modal";
import { ShipSuiteModalDataQuery } from "types/graphql-types";
import SuiteModalContent from "./SuiteModalContent";
import { snakeCase } from "src/utils/strings";
import { CruisePriceFrom } from "types/api/suite_price.d";
import useFetchModalData from "src/utils/useFetchModalData";
import { LocationSpecificOffer } from "components/useLocationSpecificOffers/types";
import { ModalBody } from "@silversea-ssc/ui-components-react";

export interface ShipSuiteModalProps extends ModalProps {
  suiteCode?: string;
  shipPath: string;
  price?: CruisePriceFrom;
  offers?: LocationSpecificOffer[];
  raqCTAUrl?: string;
}

const ShipSuiteModal: React.FC<ShipSuiteModalProps> = ({
  modal,
  shipPath,
  suiteCode,
  price,
  offers,
  raqCTAUrl
}) => {
  const { data } = useFetchModalData<ShipSuiteModalDataQuery>(
    `/suites${shipPath}`
  );

  const content = data?.ship?.suites?.find((s) =>
    s?.codes?.includes(suiteCode)
  );

  return (
    <Modal
      title={content?.card?.title?.localized}
      modal={modal}
      size="big"
      data-content-name={`modal_${snakeCase(content?.card?.title?.en || "")}`}
    >
      <ModalBody variant="wide">
        {content != null && (
          <SuiteModalContent
            suite={content}
            price={price}
            offers={offers}
            raqCTAUrl={raqCTAUrl}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ShipSuiteModal;
